import React, {createContext, useCallback, useContext, useEffect, useMemo, useRef, useState} from 'react';

import PropTypes from 'prop-types';

import {GetRequest} from '@/api/request';
import {GET_LIST_WIFI} from '@/constants/apis';
import {INTERVAL} from '@/constants/configurations';
import {WIFI_STATUS} from '@/constants/pcConstAppData';
// import useIsMounted from '@/hooks/useIsMounted';

import {useWifiStatusContext} from './WifiStatusContext';

const WifiListContext = createContext(null);

export function WifiListContextProvider({children}) {
  const ref = useRef(null);
  const [wifiList, _setWifiList] = useState(null);
  const {wifiStatus} = useWifiStatusContext();
  // const isMounted = useIsMounted();

  const connectedWifi = useMemo(() => (wifiList ? wifiList.find((wifi) => wifi.IsConnected) : null), [wifiList]);

  useEffect(() => {
    // isMounted.current &&
    if (wifiStatus === WIFI_STATUS.OFF) _setWifiList(null);
    else _getWifiList();

    _registerWifiListInterval();

    return () => {
      _clearWifiListInterval();
    };
  }, [wifiStatus]);

  const _registerWifiListInterval = () => {
    _clearWifiListInterval();
    ref.current = setInterval(_getWifiList, INTERVAL.GET_WIFI);
  };

  const _clearWifiListInterval = () => {
    if (ref.current) {
      clearInterval(ref.current);
      ref.current = null;
    }
  };

  const _getWifiList = useCallback(() => {
    if (wifiStatus !== WIFI_STATUS.OFF) {
      GetRequest(GET_LIST_WIFI).then((response) => {
        // if (!isMounted.current) return;

        if (response.data) {
          const _wifiList = response.data.map((wifi) => ({
            Name: wifi.Name,
            Strength:
              // eslint-disable-next-line no-nested-ternary
              wifi.Strength < 34 ? WIFI_STRENGTH.LOW : wifi.Strength < 67 ? WIFI_STRENGTH.MEDIUM : WIFI_STRENGTH.STRONG,
            Password: wifi.Password,
            MacAddress: wifi.MACAddress,
            IsConnected: wifi.IsConnected,
            IsAutoConnect: wifi.IsAutoConnect,
            IsEncryptionOn: wifi.IsEncryptionOn,
            HasBeenConnected: wifi.HasBeenConnected,
          }));
          _setWifiList([..._wifiList]);
        }
      });
    }
  }, [wifiStatus]);

  const changeWifiListValues = useCallback(
    (value) => {
      const tempList = wifiList.map((list) => (list.Name === value.Name ? value : list));
      _setWifiList(tempList);
    },
    [wifiList],
  );

  console.log({wifiList});

  const WifiListContextValue = useMemo(
    () => ({
      wifiList,
      connectedWifi,
      changeWifiListValues,
    }),
    [changeWifiListValues, connectedWifi, wifiList],
  );

  return <WifiListContext.Provider value={WifiListContextValue}>{children}</WifiListContext.Provider>;
}

WifiListContextProvider.propTypes = {
  children: PropTypes.any,
};

WifiListContextProvider.defaultProps = {
  children: null,
};

export const useWifiListContext = () => useContext(WifiListContext);

export const WIFI_STRENGTH = {
  LOW: 'Low',
  MEDIUM: 'Medium',
  STRONG: 'Strong',
};
